import { render } from "./ImportComponent.vue?vue&type=template&id=4aa7cd97&scoped=true"
import script from "./ImportComponent.vue?vue&type=script&lang=js"
export * from "./ImportComponent.vue?vue&type=script&lang=js"

import "./ImportComponent.vue?vue&type=style&index=0&id=4aa7cd97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa7cd97"]])

export default __exports__